"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClosingCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="closing-cta" className="relative py-24 md:py-32 bg-gradient-to-b from-[#1A3A52] to-[#0F2438] overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary rounded-lg mix-blend-overlay filter blur-[100px]" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-white rounded-lg mix-blend-overlay filter blur-[100px]" />
      </div>

      <div ref={ref} className={`container mx-auto px-4 relative z-10 max-w-4xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-white mb-6 tracking-tight">
          Send Your Panel Layout for a Fast Quote
        </h2>
        
        <p className="text-lg md:text-xl text-gray-200 mb-10 font-default max-w-3xl mx-auto leading-relaxed">
          Upload a file or a legend list and Evermark Industrial Solutions will quote material, mounting, and a real lead time — with a proof before anything is engraved, and rush options when the inspection is close.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto text-lg px-8 h-14 bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg">
            <Link to="/ContactPage">Contact Us & Get a Quote</Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-lg px-8 h-14 border-primary text-primary hover:bg-primary/10 hover:text-primary bg-transparent shadow-sm">
            
          </Button>
        </div>
      </div>
    </section>;
}